import React from 'react';
import AddCustomerForm from './AddCustomerForm';
import CustomerList from './CustomerList';
import OptimizeRouteButton from './OptimizeRouteButton';
import RouteSummary from './RouteSummary';
import { Customer } from '../types/types';
interface CustomerPanelProps {
  customers: Customer[];
  addCustomer: (customer: Customer) => void;
  toggleCustomerSelection: (id: string) => void;
  optimizeRoute: () => void;
  routeSummary: {
    distance: string;
    duration: string;
  } | null;
}
const CustomerPanel: React.FC<CustomerPanelProps> = ({
  customers,
  addCustomer,
  toggleCustomerSelection,
  optimizeRoute,
  routeSummary
}) => {
  return <div className="w-full md:w-1/3 bg-white p-4 overflow-auto shadow-md" data-id="element-52">
      <h1 className="text-2xl font-bold mb-6 text-gray-800" data-id="element-53">Route Optimizer</h1>
      <div className="mb-6" data-id="element-54">
        <h2 className="text-lg font-semibold mb-3 text-gray-700" data-id="element-55">
          Add New Customer
        </h2>
        <AddCustomerForm addCustomer={addCustomer} data-id="element-56" />
      </div>
      <div className="mb-6" data-id="element-57">
        <h2 className="text-lg font-semibold mb-3 text-gray-700" data-id="element-58">
          Customer List
        </h2>
        <CustomerList customers={customers} toggleCustomerSelection={toggleCustomerSelection} data-id="element-59" />
      </div>
      <div className="mt-auto" data-id="element-60">
        {routeSummary && <RouteSummary summary={routeSummary} data-id="element-61" />}
        <OptimizeRouteButton optimizeRoute={optimizeRoute} data-id="element-62" />
      </div>
    </div>;
};
export default CustomerPanel;